function OriZoneClassification() {
    "use strict";

    this.__type = 'OriZoneClassification:www.veritracks.com';
    this.Id = -1;
    this.OrganizationId = -1;
    this.ZoneClassificationId = -1;
    this.ZoneId = -1;

    //this.Version = 0;

    //this.CtOriId = -1;
    //this.OriTxt = '';

    //this.UpdatedUTC = -1;
    //this.OrganizationId = -1;
    //this.SortOrder = -1;
    //this.SelectedFlg = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = OriZoneClassification;
}